import { useEffect, useState } from "react";
import { Box, Avatar, Skeleton, styled } from "@mui/material";
import CachedImage from "../../../../components/common/CachedImage";
import { ImagePath } from "../../../../assets/ImagePath";
import { showToast } from "../../../../components/ui/toaster";

const CameraIconWrapper = styled(Box)({
    position: "absolute",
    top: "78%",
    cursor: "pointer",
    right: "10%",
});


export const ProfileAvatar = ({ uploading, profileImage, user, uploadPhoto = () => { } }) => {
    const [imageLoaded, setImageLoaded] = useState(false);

    useEffect(() => {
        if (!profileImage) {
            setImageLoaded(false);
            return;
        }

        const img = new Image();
        img.src = profileImage;
        img.onload = () => setImageLoaded(true);
        img.onerror = () => setImageLoaded(false);
    }, [profileImage]);


    const getAvatarText = (userName) => {
        let letters = userName
            ? userName
                .split(" ")
                .map((n) => n[0])
                .join("")
            : "";
        return letters.slice(0, 2).toUpperCase();
    };


    return (
        <Box sx={{ position: "relative" }}>
            {uploading ?
              <Skeleton
                    variant="circular"
                    width={106}
                    height={107}
                    animation="wave"
                />
            : profileImage && imageLoaded ? (
                <Avatar
                    src={profileImage}
                    sx={{
                        width: 106,
                        height: 107,
                        borderRadius: "50%",
                    }}
                />
            ) : user && user.userName ? (
                <Avatar
                    sx={{
                        bgcolor: "#c5af91",
                        width: 106,
                        height: 107,
                        fontSize: "3.5rem",
                        fontWeight: "300",
                    }}
                >
                    {getAvatarText(user.userName)}
                </Avatar>
            ) : (
                <Skeleton
                    variant="circular"
                    width={106}
                    height={107}
                    animation="wave"
                />
            )}
            <CameraIconWrapper>
                <label htmlFor="fileBrowser" style={{ cursor: 'pointer' }}>
                    <CachedImage
                        imgKey={"cameraIcons"}
                        image={ImagePath.profileCamera}
                    />
                </label>
                <input
                    style={{ position: "absolute", cursor: "pointer", display: 'none' }}
                    type="file"
                    id="fileBrowser"
                    name="customFile"
                    onChange={(e) => {
                        const file = e.target.files && e.target.files[0];
                        if (file && file.size > 5 * 1024 * 1024) {
                            e.target.value = "";
                            showToast("error", "File size should not exceed 5MB.");
                        } else {
                            uploadPhoto(e);
                        }
                    }}
                    accept=".png"
                />

            </CameraIconWrapper>
        </Box>
    );
};
